module.exports = __webpack_public_path__ + "static/media/overpass-thin.8c022f6d.woff2";